import { Button, Modal } from "@etudescarre/ui";
import { WarningIcon } from "@phosphor-icons/react";

type Props = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
};

export function SingleSessionModal({
  open,
  onConfirm,
  onCancel,
  isLoading,
}: Props) {
  return (
    <Modal.Root open={open} lazyMount unmountOnExit>
      <Modal.Portal>
        <Modal.Backdrop />
        <Modal.Positioner>
          <Modal.Content size="sm">
            <Modal.Header>
              <div className="flex items-center gap-3">
                <WarningIcon className="h-5 w-5 text-amber-500" />
                <Modal.Title>Connexion sur un autre appareil</Modal.Title>
              </div>
            </Modal.Header>

            <Modal.Body>
              <p className="text-gray-600 text-sm">
                En validant la connexion, vous serez déconnecté sur vos autres
                appareils.
              </p>

              <div className="mt-6 flex gap-3">
                <button
                  type="button"
                  onClick={onCancel}
                  disabled={isLoading}
                  className="flex-1 rounded-md border border-gray-300 px-4 py-2 text-gray-700 text-sm font-medium hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-[#1a3b5c] disabled:opacity-50"
                >
                  Annuler
                </button>
                <Button
                  className="flex-1 bg-[#1a3b5c] hover:bg-[#2a4b6c]"
                  onClick={onConfirm}
                  disabled={isLoading}
                  type="button"
                >
                  {isLoading ? "Connexion..." : "Continuer"}
                </Button>
              </div>
            </Modal.Body>
          </Modal.Content>
        </Modal.Positioner>
      </Modal.Portal>
    </Modal.Root>
  );
}
